import {
  IsNumber,
  IsString,
  IsIn,
  ValidateNested,
  IsObject,
  IsDefined,
  Max,
} from 'class-validator';
import { Type } from 'class-transformer';
import { ColorCollectionDto } from './ColorCollectionDto';
import { HeadingTypographyDto } from './HeadingTypographyDto';
import { BodyTypographyDto } from './BodyTypographyDto';
import { LinkCollectionDto } from './LinkCollectionDto';
import { ButtonDto } from './ButtonDto';
import { CURRENT_STYLE_VERSION } from '@builder4/shared/migrations/style/registry';

export class TypographyDto {
  @IsDefined()
  @IsString()
  @IsIn(['px'])
  fontSizeUnit!: 'px';

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingTypographyDto)
  heading!: HeadingTypographyDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => BodyTypographyDto)
  body!: BodyTypographyDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => LinkCollectionDto)
  link!: LinkCollectionDto;
}

export class ButtonsDto {
  @IsDefined()
  @IsString()
  @IsIn(['px'])
  fontSizeUnit!: 'px';

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonDto)
  @IsObject()
  button1!: ButtonDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonDto)
  @IsObject()
  button2!: ButtonDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonDto)
  @IsObject()
  button3!: ButtonDto;

  // Index signature to allow dynamic access
  [key: string]: ButtonDto | 'px';
}

export class StylesConfigDto {
  @IsDefined()
  @IsNumber()
  @Max(CURRENT_STYLE_VERSION) // don't allow version numbers higher than we support
  version!: number;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorCollectionDto)
  colors!: ColorCollectionDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => TypographyDto)
  typography!: TypographyDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ButtonsDto)
  buttons!: ButtonsDto;
}
